import React from "react";
import { Container, Button, Table } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import "../components/Contact.css";

export default function ConfirmPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const data     = location.state;

  // データがない場合はフォームへリダイレクト
  if (!data) {
    navigate("/contact");
    return null;
  }

  const handleBack = () => navigate("/contact", { state: data });

  const handleSubmit = () => {
    fetch("/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === "ok") {
          navigate("/contact/complete");
        } else {
          alert("送信に失敗しました: " + result.message);
        }
      })
      .catch(() => alert("送信に失敗しました"));
  };

  // 表示する項目定義（ラベルとデータキーを紐づけ）
  const ROWS = [
    { label: "会社名",         key: "company" },
    { label: "担当者名",       key: "name" },
    { label: "電話番号",       key: "phone" },
    { label: "メールアドレス", key: "email" },
    { label: "お問い合わせ内容", key: "message" },
  ];

  return (
    <div className="contact-page-wrapper">
      <Container className="contact-container">
        <h2>内容確認</h2>

        <Table bordered>
          <tbody>
            {ROWS.map(({ label, key }) => (
              <tr key={key}>
                <th>{label}</th>
                <td>{data[key]}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Button variant="secondary" onClick={handleBack}>戻る</Button>
        <Button variant="primary"   onClick={handleSubmit} className="ms-2">送信</Button>
      </Container>
    </div>
  );
}